import type { Font } from "~/types/PlatformConfiguration";

export const getFontFaceDefinition = (font: Font, fontFamilyName: string) => {
  return `
    @font-face {
      font-family: ${fontFamilyName};
      font-style: normal;
      font-weight: ${font.weight};
      font-display: swap;
      src: url("${font.url}") format('truetype');
    }
  `;
};

export const getFontFaceDefinitions = (
  fonts: Font[],
  fontFamilyName: string,
) => {
  return fonts
    .map((font) => getFontFaceDefinition(font, fontFamilyName))
    .join("\n");
};
